import type { FeeDisplayModel } from "../lib/feeDisplay";
import { Card, Pill } from "./ui";

/** Presentational fee panel. Always shows gas; never labels a launch "free". */
export function FeeDisplay({ model }: { model: FeeDisplayModel }) {
  return (
    <Card accent={model.teamExempt} className="space-y-4">
      {/* Team access header */}
      {model.teamExempt && (
        <div className="flex items-center gap-2">
          <Pill tone="plasma">SYNAPZ Team Access Active</Pill>
        </div>
      )}
      {model.teamBanner && (
        <p className="text-sm text-plasma/90 leading-relaxed">{model.teamBanner}</p>
      )}

      {/* Fee rows */}
      <dl className="space-y-2.5 text-sm">
        <Row label={model.platformFeeLabel} value={model.platformFeeValue} />
        <Row label={model.gasLabel} value={model.gasValue} />
        {model.gasUnitsDetail && (
          <div className="flex justify-end -mt-1.5">
            <span className="text-[11px] text-muted font-mono">
              {model.gasUnitsDetail}
            </span>
          </div>
        )}
        <div className="border-t border-line pt-2.5">
          <Row label={model.totalLabel} value={model.totalValue} strong />
        </div>
      </dl>

      {/* Gas reminder */}
      <p className="text-xs text-warn/90 flex items-start gap-1.5">
        <svg
          aria-hidden="true"
          width="13"
          height="13"
          viewBox="0 0 12 12"
          fill="currentColor"
          className="shrink-0 mt-[1px]"
        >
          <path d="M6 1a5 5 0 110 10A5 5 0 016 1zm0 3.5a.75.75 0 00-.75.75v2.5a.75.75 0 001.5 0v-2.5A.75.75 0 006 4.5zm0 5.25a.75.75 0 100-1.5.75.75 0 000 1.5z" />
        </svg>
        {model.gasReminder}
      </p>
    </Card>
  );
}

function Row({
  label,
  value,
  strong,
}: {
  label: string;
  value: string;
  strong?: boolean;
}) {
  return (
    <div className="flex items-center justify-between gap-3">
      <dt className="text-muted">{label}</dt>
      <dd
        className={`font-mono tabular-nums ${
          strong ? "text-ink font-bold text-base" : "text-ink"
        }`}
      >
        {value}
      </dd>
    </div>
  );
}
